import { forwardRef } from 'react'

import { Container, ControlButtons, LinkPreview, TooltipBody } from './parts'

const LinkTooltip = forwardRef(
  ({ isOpen, url, position, onEdit, onRemove, useNarrowTooltip = false }, ref) => {
    const { left, top } = position
    if (!isOpen) {
      return null
    }

    return (
      <TooltipBody
        data-component="rich-text-editor-tooltip"
        top={top}
        left={left}
        ref={ref}
        useNarrowTooltip={useNarrowTooltip}
      >
        <LinkPreview url={url} />
        <ControlButtons
          onEdit={onEdit}
          onRemove={onRemove}
        />
      </TooltipBody>
    )
  }
)

const BoxWithLinkTooltip = forwardRef(
  ({ children, useNarrowTooltip = false, ...props }, ref) => (
    <Container>
      {children}
      <LinkTooltip
        {...props}
        ref={ref}
        useNarrowTooltip={useNarrowTooltip}
      />
    </Container>
  )
)

export { BoxWithLinkTooltip }
